<ul class="m-portlet__nav">
    <li class="m-portlet__nav-item">
        <trt-wid-m-term-badge [status]="formData?.availabilityStatus" class="mr-2"></trt-wid-m-term-badge>

        <ng-container *ngIf="formData.availabilityStatus == availabilityStatus.BOOKED">
            <a
                (click)="openReservation()"
                ngbTooltip="Odpri termin"
                container="body"
                class="m-portlet__nav-link m-portlet__nav-link--icon text-decoration-none mf-cursor-pointer"
            >
                <i class="la la-eye"></i>
            </a>
        </ng-container>

        <ng-container
            *ngIf="formData.availabilityStatus != availabilityStatus.BOOKED && treatment?.isTreatmentCreated && !formData?.prereservationId"
        >
            <a
                (click)="makeReservatonForSingle()"
                ngbTooltip="Rezerviraj termin"
                container="body"
                class="m-portlet__nav-link m-portlet__nav-link--icon text-decoration-none mf-cursor-pointer"
            >
                <i class="la la-calendar-plus-o"></i>
            </a>
        </ng-container>
        <ng-container *ngIf="formData.availabilityStatus != availabilityStatus.BOOKED && formData?.prereservationId">
            <a
                (click)="updateReservatonForSingle()"
                ngbTooltip="Shrani termin"
                container="body"
                class="m-portlet__nav-link m-portlet__nav-link--icon text-decoration-none mf-cursor-pointer"
            >
                <i class="la la-edit"></i>
            </a>
        </ng-container>

        <ng-container *ngIf="formData.availabilityStatus != availabilityStatus.BOOKED">
            <a
                *ngIf="!isLoadingTermChecking"
                (click)="checkTermAvailability(); isLoadingTermChecking = true"
                ngbTooltip="Preveri termin"
                container="body"
                class="m-portlet__nav-link m-portlet__nav-link--icon text-decoration-none mf-cursor-pointer"
            >
                <i class="la la-refresh"></i>
            </a>
            <span *ngIf="isLoadingTermChecking" ngbTooltip="Preverjam termin" container="body" class="m-loader m-loader--brand mr-3"></span>
        </ng-container>
        <div
            x-placement="bottom-end"
            style="position: absolute; transform: translate3d(-64px, 70px, 0px); top: 0px; left: 0px; will-change: transform"
            class="dropdown-menu dropdown-menu-right"
        >
            <ng-container *ngIf="formData.availabilityStatus != availabilityStatus.BOOKED">
                <a (click)="checkTermAvailability(); isLoadingTermChecking = true" class="dropdown-item cursor mf-cursor-pointer">Preveri termin</a>
                <a (click)="removeTerm()" class="dropdown-item cursor m--font-danger mf-cursor-pointer">Izbriši</a>
            </ng-container>
            <ng-container *ngIf="formData.availabilityStatus == availabilityStatus.BOOKED">
                <a (click)="openReservation()" class="dropdown-item cursor mf-cursor-pointer">Odpri termin</a>
                <a (click)="removeReservation()" class="dropdown-item cursor m--font-danger mf-cursor-pointer">Izbriši termin</a>
            </ng-container>
        </div>
        <a
            ngbTooltip="Akcije"
            container="body"
            style="cursor: pointer"
            data-toggle="dropdown"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
            class="m-portlet__nav-link m-portlet__nav-link--icon"
        >
            <i class="la la-ellipsis-v"></i>
        </a>
        <ng-container>
            <a
                (click)="toggleExpand()"
                ngbTooltip="Prikaži/skrij podrobnosti"
                container="body"
                class="m-portlet__nav-link m-portlet__nav-link--icon text-decoration-none mf-cursor-pointer"
            >
                <i class="la" [ngClass]="formData?.isDetailsOpend ? 'la-angle-up' : 'la-angle-down'"></i>
            </a>
        </ng-container>
    </li>
</ul>
